import type { SyncTask } from "@/stores/taskStore";

// Mirrors app/models/concerns/my_day_scheduling.rb on one save of `next` (mutated in
// place) over `before` (null for a new task). The rules run in the concern's order:
// pinning to today is what arms the dismissal sync.
export function applyMyDayScheduling(before: SyncTask | null, next: SyncTask, today: string): void {
  const changed = (key: "dueOn" | "myDayOn") => (before ? before[key] !== next[key] : next[key] !== null);

  if (changed("dueOn")) {
    if (next.dueOn === today) next.myDayOn = today;
    if (next.dueOn !== null && next.dueOn > today && next.myDayOn === today) next.myDayOn = null;
    if (next.dueOn === null && before?.dueOn === today && next.myDayOn === today) next.myDayOn = null;
  }

  if (changed("myDayOn")) {
    if (next.myDayOn === null && next.dueOn === today) next.myDayDismissedOn = today;
    else if (next.myDayOn === today) next.myDayDismissedOn = null;
  }

  const leavesBoard = before !== null && (changed("myDayOn") || (changed("dueOn") && next.myDayOn !== today));
  if (leavesBoard) {
    next.myDayPosition = null;
    next.myDaySequentialOn = null;
  }
}
